<template>
  <!--
          作者：luoyiming
          时间：2019-10-25
          描述：商户-商户管理
      -->
  <div class="user clearfix">

    <!--添加商户-->
    <div class="common-level-rail fl">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick"
        v-auth="'/cityagency/cityagency/add'">添加城市代理</el-button>
    </div>
    
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <!-- <el-table-column prop="shopSupplierId" label="商户ID" width="90"></el-table-column> -->
          <el-table-column prop="name" label="代理账号名称"></el-table-column>
          <el-table-column prop="superUser.userName" label="登录账号"></el-table-column>
          <el-table-column label="头像图片" width="80">
            <template slot-scope="scope" v-if="scope.row.logo">
              <el-image style="width:60px;height:60px" fit="cover" :src="scope.row.logo.file_url" alt=""
                :preview-src-list="[scope.row.logo.file_url]">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="linkName" label="联系人"></el-table-column>
          <el-table-column prop="linkPhone" label="联系电话"></el-table-column>
          <el-table-column  label="分成比例">
            <template slot-scope="scope">
              <div v-if="scope.row">{{scope.row.scale}}%</div>
            </template>
          </el-table-column>
          <el-table-column prop="agent_city_ids" label="代理城市">
            <template slot-scope="scope" v-if="scope.row.agentCityArr">
              <div style="display: flex;flex-direction: column; align-items: center;" v-if="scope.row.agentCityArr[0]">
                <div>
                  {{scope.row.agentCityArr[0].mergerName}}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="createTime" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">

              <el-button @click="editClick(scope.row)" type="primary" size="small"
                v-auth="'/cityagency/cityagency/edit'">编辑</el-button>
              <el-button @click="deleteClick(scope.row.shopSupplierId)" type="danger" size="small"
                v-auth="'/cityagency/cityagency/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import CityagencyApi from "@/api/cityagency.js";
export default {
  components: {},
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*门店列表数据*/
      storeList: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        shop_id: "",
        search: "",
        serviceCityId: ""
      },
      citydata: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      logoImgs: [],
      businessImgs: []
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    getCityName(cityId) {
      const city = this.citydata.find(city => city.city_id == cityId);
      return city ? city.city : "暂无";
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      Params.name = self.formInline.search;
      Params.serviceCityId = self.formInline.serviceCityId;
      CityagencyApi.Cityagencylist(Params, true)
        .then(res => {
          self.loading = false;
          self.tableData = res.data.list.data;
          self.citydata = res.data.data;
          self.totalDataNumber = res.data.list.total;
          // const filteredData = res.data.data.filter(item => ids.includes(item.city_id));
          // self.tableData.forEach(function (item) {
          //   if (item.business) {
          //     self.businessImgs.push(item.business.filePath);
          //   }
          //   if (item.logo) {
          //     self.logoImgs.push(item.logo.filePath);
          //   }
          // });
        })
        .catch(error => {
          self.loading = false;
        });
    },
    getLogoList(index) {
      return this.logoImgs.slice(index).concat(this.logoImgs.slice(0, index));
    },
    getBusinessList(index) {
      return this.businessImgs
        .slice(index)
        .concat(this.businessImgs.slice(0, index));
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*打开添加*/
    addClick() {
      this.$router.push("/cityagency/cityagency/add");
    },

    /*打开编辑*/
    editClick(row) {
      let self = this;
      let params = row.shopSupplierId;
      this.$router.push({
        path: "/cityagency/cityagency/edit",
        query: {
          shopSupplierId: params
        }
      });
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("删除商户，商户下的相关师傅也会被删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          self.loading = true;
          CityagencyApi.deleteCityagency(
            {
              shopSupplierId: row
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: "恭喜你，商户删除成功",
                  type: "success"
                });
                self.getTableList();
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/cityagency/cityagency/index.vue